export const API_BUILDER_LOCAL_RULE_FIELDS=(t) => [
    // { label: "--------", value: "empty" },
    { label: t("COLUMN_BRN"), value: "Brn" },
    // { label: t("COLUMN_CR_NO"), value: "Cr_no" },
    { label: t("COLUMN_LOCAL_COM"), value: "Comp_name" },
    // { label: t("COLUMN_LOCAL_COM_ENG_NAME"), value: "Comp_name_eng" },
    // { label: t("COLUMN_LOCAL_COM_CHI_NAME"), value: "Comp_name_chi" },
];
export const API_BUILDER_FOREIGN_RULE_FIELDS =(t)=> [
    // { label: "--------", value: "empty" },
    { label: t("COLUMN_BRN"), value: "Brn" },
    // { label: t("COLUMN_CR_NO"), value: "Cr_no" },
    { label: t("COLUMN_LOCAL_COM"), value: "Corp_name_full" },
    // { label: t("COLUMN_CORPORATE_NAME"), value: "Corp_name" },
    // { label: t("COLUMN_OTHER_CORPORATE_NAME"), value: "Other_corp_names" },
];
export const API_BUILDER_LOCAL_RULE_FILTER=(t) => ({
    "Brn":[
        { label: t("EQUALS"), value: "equal" },
    ],
    //"Cr_no":[
    //    { label: t("EQUALS"), value: "equal" },
    //],
    "Comp_name":[
        // { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        // { label: t("END_WITH"), value: "end_with" },
        // { label: t("CONTAINS"), value: "contains" },
    ],
    "Comp_name_eng":[
        { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        { label: t("CONTAINS"), value: "contains" },
    ],
    "Comp_name_chi":[
        { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        { label: t("CONTAINS"), value: "contains" },
    ],
    // "sample":[
    //     { label: t("EQUALS"), value: "equal" },
    //     { label: "Not Equal", value: "not_equal" },
    //     { label: "In", value: "in" },
    //     { label: "Not In", value: "not_in" },
    //     { label: "Begins with", value: "begins_with" },
    //     { label: "Doesn't Begins with", value: "not_begins_with" },
    //     { label: "Contains", value: "contains" },
    //     { label: "Doesn't Contains", value: "not_contains" },
    //     { label: "Ends with", value: "ends_with" },
    //     { label: "Doesn't End with", value: "not_ends_with" },
    // ]
});
export const API_BUILDER_FOREIGN_RULE_FILTER =(t) => ({
    "Brn":[
        { label: t("EQUALS"), value: "equal" },
    ],
    //"Cr_no":[
    //    { label: t("EQUALS"), value: "equal" },
    //],
    "Corp_name_full":[
        // { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        // { label: t("CONTAINS"), value: "contains" },
    ],
    "Corp_name":[
        { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        { label: t("CONTAINS"), value: "contains" },
    ],
    "Other_corp_names":[
        { label: t("EQUALS"), value: "equal" },
        { label: t("BEGINS_WITH"), value: "begins_with" },
        { label: t("CONTAINS"), value: "contains" },
    
    
]});
export const API_BUILDER_LOCAL_RULE_SORT = [
{ label: "Ascending", value: "asc" },
{ label: "Descending", value: "desc" },
];
export const STATUS_LABEL = {
    true: "Active",
    false: "Inactive",
    active: "Active",
    inactive: "Inactive",
};
export const USER_TYPE = {
    normal_user: "Normal User",
    division_admin: "Division Admin",
    system_admin: "System Admin",
};
export const STATUS = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
];

export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!_%*?&]{10,}$/m;
export const PASSWORD_ERR_MSG = "At least 10 characters, password MUST have at least one Capital letter, one small letter and one number.";


// WEBPACK FOOTER //
// src/constants/constants.js